import React from "react";
import WorkRequestContainer from "src/components/molecules/WorkRequestContainer";
import { WORK_REQUEST_TYPE } from "../constants";
import { WorkRequestProps } from "../types";

const VendorWorkRequests = ({ renderTable }: WorkRequestProps) => {
  return (
    <WorkRequestContainer
      tabs={[
        {
          eventKey: WORK_REQUEST_TYPE.NEW,
          label: "New",
        },
        {
          eventKey: WORK_REQUEST_TYPE.IN_PROGRESS,
          label: "In Progress",
        },
        {
          eventKey: WORK_REQUEST_TYPE.REQUIRES_APPROVAL,
          label: "Requires Approval",
        },
        {
          eventKey: WORK_REQUEST_TYPE.COMPLETED,
          label: "Completed",
        },
        {
          eventKey: WORK_REQUEST_TYPE.INSPECTIONS,
          label: "Preventative Maintenance",
        },
        {
          eventKey: WORK_REQUEST_TYPE.ALL,
          label: "All",
        },
      ]}
      isBreadCumVisible={true}
      renderTable={renderTable}
    />
  );
};

export default VendorWorkRequests;
